export const GET_INDIVIDUAL_INSTANCES = 'providers/individualInstances/GET_INDIVIDUAL_INSTANCES';
export const EDIT_INDIVIDUAL_INSTANCE = 'providers/individualInstances/EDIT_INDIVIDUAL_INSTANCE';
export const CHECK_HEALTH = 'providers/individualInstances/CHECK_HEALTH';
